import { useState, type ReactNode } from 'react';
import { Drawer, Heading, TextPassage, TextLink } from '@petsmart-ui/sparky';
import { parseRichText, type ParseRichTextParameter } from '@libs/contentful';
import type { AutoShipDrawerProps } from './types';
import './AutoShip.scss';

export default function AutoShipDrawer({
    linkText,
    autoship,
}: AutoShipDrawerProps) {
    const [isActive, setIsActive] = useState(false);

    return (
        <>
            <TextLink
                onClick={() => setIsActive(true)}
                className="sparky-u-display-block"
            >
                {linkText}
            </TextLink>
            <Drawer
                align="right"
                className="autoship-drawer"
                isActive={isActive}
                onClose={() => setIsActive(false)}
            >
                <Drawer.Header>
                    <Heading size="headline" tagName="h2">
                        {!!autoship?.fields?.header &&
                            (autoship.fields.header as ReactNode)}
                    </Heading>
                </Drawer.Header>
                <Drawer.Body>
                    <TextPassage
                        data-testid="autoship-drawer-body"
                        className="product-promotion-details-text"
                    >
                        {!!autoship?.fields?.body &&
                            parseRichText(
                                autoship.fields.body as ParseRichTextParameter
                            )}
                    </TextPassage>
                </Drawer.Body>
                <Drawer.Footer>
                    <TextPassage
                        data-testid="autoship-drawer-footer"
                        className="product-promotion-footer-text"
                    >
                        {!!autoship?.fields?.footer &&
                            parseRichText(
                                autoship.fields.footer as ParseRichTextParameter
                            )}
                    </TextPassage>
                </Drawer.Footer>
            </Drawer>
        </>
    );
}
